export const config = {
  captchaProvider: (process.env.REACT_APP_CAPTCHA_PROVIDER || 'recaptcha') as 'recaptcha',
  captchaSiteKey: process.env.REACT_APP_CONTACT_RECAPTCHA_SITE_KEY || '',
  mintUrl: process.env.REACT_APP_CONTACT_API_BASE ? `${process.env.REACT_APP_CONTACT_API_BASE.replace(/\/$/, '')}/mint-token` : '',
  mailerUrl: process.env.REACT_APP_CONTACT_API_BASE ? `${process.env.REACT_APP_CONTACT_API_BASE.replace(/\/$/, '')}/v1/contact` : '',
  mode: (process.env.REACT_APP_CONTACT_AUTH_MODE || 'cookie') as 'cookie' | 'dpop',
} as const;

export function validateConfig(): void {
  if (!config.captchaSiteKey || !config.mintUrl || !config.mailerUrl) {
    throw new Error('The contact form is currently unavailable. Please try again later or contact us directly via email.');
  }
}


